// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8428":"0fd1a85c","8692":"0fd1a85c"}[chunkId] + ".chunk.css";
};